Librarian.ViewFeedbackWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onFeedbackLoaded", "onSubmitClicked"],

    options: {
        id: "ViewFeedbackWindow",
        itemType: null,
        itemData: null,
        width: 505,
        height: 425
    },

    feedbackTemplate: Handlebars.compile("{{#each List}} \
                                            <span class=\"feedback-date\">{{#formattedDate format=\"%B %d, %Y\" date=\"{{ModifiedDate}}\"}}{{/formattedDate}}</span> \
                                        </div> \
                                        <div class=\"feedback-comment-view-comment\"> \
                                            <span class=\"feedback-user\">By <span class=\"feedback-user-name\">{{FirstName}} {{LastName}}</span></span> \
                                            <span class=\"feedback-view-text\">{{#comment string=\"{{CommentText}}\"}}{{/comment}}</span> \
                                        </div> \
                                        <hr class=\"feedback-comment-view-break\" /> \
                                      {{/each}}"),

    initialize: function (options) {
        this.setOptions(options);

        if (this.options.itemData == null)
            return;

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("Feedback");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/ratings/viewFeedbackWindow.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.parent();
        this.setupElements();

        var FeedbackTitle = Librarian.Lang.getString("feedback_comments");
        var type = Librarian.Utils.getItemTypeString(this.options.itemData);
        if (this.options.itemType == "slide") {
                FeedbackTitle += ' ' + type.toLowerCase() + " #" + this.options.itemData.slidenumber;
        }
        else if (type = "Group") FeedbackTitle += ' ' + type.toLowerCase();
        Librarian.Utils.setElementValue(this.getElement("feedbackType"), FeedbackTitle + ": ");

        itemEl = this.getElement("feedbackCancel");
        if (itemEl)
            itemEl.addOnClick(this.close, this);

        itemEl = this.getElement("feedbackSubmit");
        if (itemEl)
            itemEl.addOnClick(this.onSubmitClicked, this);

        var name;
        if (this.options.itemType == "file") {
            if (this.options.itemData.presid > 0)
                name = this.options.itemData.name;
            else
                name = this.options.itemData.groupname || this.options.itemData.filename || this.options.itemData.name;
        }
        else {
            name = this.options.itemData.filename || this.options.itemData.name;

            // If this name ends in the extension of the file, strip it off because this is a slide/page
            var ext = Librarian.Utils.getExtensionFromData(this.options.itemData, true);
            if ((ext.length > 0) && name.endsWith(ext))
                name = name.substring(0, name.length - ext.length - 1);
        }

        if ((typeof name != "undefined") && (name != null))
            Librarian.Utils.setElementValue(this.getElement("feedbackName"), name);

        Handlebars.registerHelper("translate", function (options) {
            var data = Handlebars.compile(options.hash.data);
            return Librarian.Lang.getString(options.hash.string + data(this)) + ", ";
        });

        Handlebars.registerHelper("comment", function (options) {
            var comment = Handlebars.compile(options.hash.string);
            return comment(this).replaceAll("\n", "<br />");
        });

        var id = "";
        var type = "";
        // Build the ID string for files and groups
        if (this.options.itemData.groupid > 0) {
            id += this.options.itemData.groupid;
            if (typeof this.options.itemData.eventcount == "number")
                id += Librarian.contentType.eventGroup;
            else
                id += Librarian.contentType.globalFavorite;
        }
        else if (this.options.itemData.presid > 0) {
            id += this.options.itemData.presid;
            type += Librarian.contentType.myFavorite;
        }
        else if (this.options.itemData.fileid > 0) {
            id += this.options.itemData.fileid;
            type += Librarian.contentType.file;
        }
        else if (this.options.itemData.eventgroupinfo && (this.options.itemData.eventgroupinfo.groupid > 0)) {
            id += this.options.itemData.eventgroupinfo.groupid;
            type += Librarian.contentType.eventGroup;
        }

        // If this is a slide
        if (this.options.itemType == "slide") {
            // Use the slide ID if we can
            if (this.options.itemData.slideid > 0) {
                id = this.options.itemData.slideid;
                type = Librarian.contentType.slide;
            }
                // Otherwise, use the slide number
            else
                id += this.options.itemData.slidenumber;
        }
        Librarian.ViewFeedbackWindow.getComments(id, type, this.onFeedbackLoaded, Librarian.Utils.onFailure);
    },

    onClose: function () {
        this.parent();

        if (this.request) {
            this.request.cancel();
            this.request = null;
        }
    },

    onSubmitClicked: function (e) {
        var evt = new Event(e),
            buttonEl = $(evt.target);
        if (!buttonEl || buttonEl.hasClass("disabled"))
            return;
        var type = "";

        var comment = (Librarian.Utils.getElementValue(this.getElement("feedbackComment")) || '').trim()
        var id = "";

        // Build the ID string for files and groups
        if (this.options.itemData.groupid > 0) {
            id += this.options.itemData.groupid;
            if (typeof this.options.itemData.eventcount == "number")
                id += Librarian.contentType.eventGroup;
            else
                id += Librarian.contentType.globalFavorite;
        }
        else if (this.options.itemData.presid > 0) {
            id += this.options.itemData.presid;
            type += Librarian.contentType.myFavorite;
        }
        else if (this.options.itemData.fileid > 0) {
            id += this.options.itemData.fileid;
            type += Librarian.contentType.file;
        }
        else if (this.options.itemData.eventgroupinfo && (this.options.itemData.eventgroupinfo.groupid > 0)) {
            id += this.options.itemData.eventgroupinfo.groupid;
            type += Librarian.contentType.eventGroup;
        }

        // If this is a slide
        if (this.options.itemType == "slide") {
            // Use the slide ID if we can
            if (this.options.itemData.slideid > 0) {
                id = this.options.itemData.slideid;
                type += Librarian.contentType.slide;
            }
            else if (this.options.itemData.eventid > 0) {
                id = this.options.itemData.eventid;
                type += Librarian.contentType.event;
            }
                // Otherwise, use the slide number
            else
                id +=this.options.itemData.slidenumber;
        }

        // Validate comment length
        if (comment.length > 2000) {
            Librarian.Utils.error(Librarian.Lang.getArgString("feedback_comment_length", [2000]));
            return;
        }

        var feedback = {
            cmtxt: comment,
            out: "ujson"
        };

        Librarian.ViewFeedbackWindow.addComment(id, type, comment, function (newComment) {
            Librarian.Utils.notification(Librarian.Lang.getString("feedback_comment_added"));
            this.fireEvent("ratingAdded", newComment);
            this.close();
        }.bind(this), function () {
                Librarian.Utils.error(Librarian.Lang.getString("feedback_save_error"));
            }.bind(this)
    )},

    onFeedbackLoaded: function (json) {
        var jsonList = { List: json };
        if (!jsonList || !jsonList.List || (jsonList.List.length == 0))
            return;

        this.getElement("feedbackComments").set("html", this.feedbackTemplate(jsonList));
    }
})
// Static Methods
.extend({
    getComments: function(contentId, contentType, onSuccess, onFailure) {
        var params = {
            cmtype: Librarian.commentType.webLibrary,
            cntid: contentId,
            cnttype: contentType,
            "out": "ujson"
        };
        var method = "getcms";

        Librarian.ViewFeedbackWindow.sendRequest(method, params, null, onSuccess, onFailure);
    },

    addComment: function(contentId, contentType, commentText, onSuccess, onFailure) {
        var method = "addcm";
        var data = {
            commentType: Librarian.commentType.webLibrary,
            contentId: contentId,
            contentType: contentType,
            commentText: commentText
        }
        var params = {
            "in": "cjson",
            "out": "ujson"
        }

        Librarian.ViewFeedbackWindow.sendRequest(method, params, data, onSuccess, onFailure, "post");
    },

    deleteComment: function(commentId, onSuccess, onFailure) {
        var method = "delcm";
        var params = {
            cmid: commentId
        };

        Librarian.ViewFeedbackWindow.sendRequest(method, params, null, onSuccess, onFailure);
    },

    editComment: function(commentId, commentText, onSuccess, onFailure) {
        var method = "setcmt";
        var params = {
            cmid: commentId,
            cmtxt: commentText,
            "out": "ujson"
        };

        Librarian.ViewFeedbackWindow.sendRequest(method, params, null, onSuccess, onFailure);
    },

    sendRequest: function(apiMethod, params, data, onSuccess, onFailure, method) {
        method = method || "get";
        onFailure = onFailure || Librarian.Utils.onFailure;
        var url = Librarian.path.getCommentsUrl(apiMethod) + "&" + Object.toQueryString(params);

        new Librarian.Request.JSON({
            url: url,
            onSuccess: onSuccess || $empty,
            onFailure: onFailure || $empty,
            method: method,
            data: method == "post" ? Base64.encode(JSON.stringify(data)) : null
        }).send();
    }
});